import { Modal } from "antd";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";

type RefModalContextType = {
  openModal: (content: ReactNode, callback?: () => void) => void;
  closeModal: () => void;
  content: ReactNode | null;
  isVisible: boolean;
};

type RequeryType = {
  modalContent: ReactNode;
  onOpen?: () => void;
};

const RefModalContext = createContext<RefModalContextType | undefined>(
  undefined,
);

export const RefModalProvider = ({ children }: { children: ReactNode }) => {
  const [content, setContent] = useState<ReactNode | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  const openModal = (content: ReactNode, callback?: () => void) => {
    setContent(content);
    setIsVisible(true);
    if (callback) {
      callback();
    }
  };

  const closeModal = () => {
    setContent(null);
    setIsVisible(false);
  };

  return (
    <RefModalContext.Provider
      value={{ openModal, closeModal, content, isVisible }}
    >
      {children}
      <Modal open={isVisible} onCancel={closeModal} centered footer={null}>
        {content}
      </Modal>
    </RefModalContext.Provider>
  );
};

export const useRefModal = () => {
  const context = useContext(RefModalContext);
  if (!context)
    throw new Error("useRequery must be used within RequeryProvider");
  return context;
};

export const useRequery = ({ modalContent, onOpen }: RequeryType) => {
  const [params] = useSearchParams();
  const { openModal } = useRefModal();
  const [hasResolved, setHasResolved] = useState(false);

  const ref = params.get("ref");
  const status = params.get("status");

  useEffect(() => {
    setTimeout(() => {
      if (!ref || hasResolved) return;
      if (ref && status) {
        if (
          status === "00" ||
          status?.toLowerCase().includes("success") ||
          status === "200"
        ) {
          openModal(modalContent, onOpen);
          setHasResolved(true);
        }
      }
      // if (!!status) {
      //   if (status === "00" || status?.toLowerCase()?.includes("success")) {
      //     openModal(modalContent, onOpen);
      //     setHasResolved(true);
      //   }
      //   // else if (status?.toLowerCase()?.includes("success")) {
      //   //   queryTransaction
      //   //     .refetch()
      //   //     .then((res) => {
      //   //       if (
      //   //         res?.data &&
      //   //         res?.data?.transactionStatus === TransactionStatus.Success
      //   //       ) {
      //   //         openModal(modalContent, onOpen);
      //   //       }
      //   //     })
      //   //     .finally(() => {
      //   //       setHasResolved(true);
      //   //     });
      //   // }
      // }
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, status]);
};
